import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static values = {
    selectedCountry: String,
    agentEmail: String
  }

  getAgentData(event) {
    event.preventDefault();
    this.fetchData(
      "#co_sponsor_form_agent_email",
      "#co_sponsor_form_agent_email_container",
      {
        name: "#co_sponsor_form_agent_name",
        agent_uuid: "#co_sponsor_form_agent_uuid",
        sponsor_uuid: "#co_sponsor_form_sponsor_uuid",
        active_date: "#co_sponsor_form_agent_active_date",
      },
      "#active-agent-error",
      "/co_sponsor/agents?search_type=agent",
      "No active agent found",
      "Something went wrong with finding the agent",
      "#active-agent-validate",
      () => {
        // This is the success callback function
        document.querySelector("#active-agent-validate").classList.remove("vanish");
        document.querySelector("#agent-name").textContent = document.querySelector("#co_sponsor_form_agent_name").value;
      },
      "#verify-valid-agent-checkbox",
    );
  }

  getCoSponsorData(event) {
    event.preventDefault();

    if (document.querySelector('#co_sponsor_form_co_sponsor_email').value == this.agentEmailValue) {
      super.renderToast("global-flash-msg-container", "Co-Sponsor can not be same as Agent", "danger", false, null, 6000);
    } else {
      this.fetchData(
        "#co_sponsor_form_co_sponsor_email",
        "#co_sponsor_form_co_sponsor_email_container",
        {
          name: "#co_sponsor_form_co_sponsor_name",
          agent_uuid: "#co_sponsor_form_co_sponsor_uuid",
        },
        "#active-co-sponsor-error",
        "/co_sponsor/agents?search_type=co_sponsor",
        "No active co-sponsor found",
        "Something went wrong with finding the co sponsor",
        "#active-co-sponsor-validate",
        () => {
          // This is the success callback function
          document.querySelector("#active-co-sponsor-validate").classList.remove("vanish");
          document.querySelector("#co-sponsor-name").textContent = document.querySelector("#co_sponsor_form_co_sponsor_name").value;
        },
        "#verify-valid-co-sponsor-checkbox",
      );
    }
  }

  fetchData(emailSelector, containerSelector, fieldSelectors, errorSelector, urlPrefix, notFoundError, generalError, confirmationSelector = null, successCallback = null, checkboxSelector = null) {
    const emailField = document.querySelector(emailSelector);
    const container = document.querySelector(containerSelector);
    const agentActiveDateErrorEl = document.querySelector('#agent-active-date-error');
    const secondaryAgentErrorEl = document.querySelector('#secondary-agent-error');
    const agentEmailMatchEl = document.querySelector('#agent-email-match-error');
    const agentDeferredEl = document.querySelector('#agent-deferred-error');
    const agentExcludedEl = document.querySelector('#agent-excluded-error');
    const coSponsorExcludedEl = document.querySelector('#co-sponsor-excluded-error');
    const errorEl = document.querySelector(errorSelector);
    const inputSubmitBtn = container.querySelector(".input--submit-container--btn");
    const inputSubmitBtnText = container.querySelector(".input--submit-container--btn--text");
    const inputSubmitBtnLoader = container.querySelector(".input--submit-container--btn--loader");
    const selectionFormSubmitBtn = document.querySelector("#co_sponsor_form").querySelector("#form-submit-btn");

    inputSubmitBtnText.textContent = "Submitting...";
    inputSubmitBtn.setAttribute('disabled', 'disabled');
    inputSubmitBtnLoader.classList.remove("vanish");

    // disable form button
    selectionFormSubmitBtn.setAttribute("disabled", "disabled");
    selectionFormSubmitBtn.classList.add("disabled");

    // Reset validation container
    document.querySelectorAll(".co-sponsor-search-result--container").forEach(function(el) {
      el.classList.add('vanish');
    });

    document.querySelector(checkboxSelector).checked = false;

    // Reset validation hidden values
    for (const [key, selector] of Object.entries(fieldSelectors)) {
      document.querySelector(selector).value = "";
    }

    if (agentActiveDateErrorEl) { agentActiveDateErrorEl.classList.add('vanish'); }
    if (secondaryAgentErrorEl) { secondaryAgentErrorEl.classList.add('vanish'); }
    if (agentEmailMatchEl) { agentEmailMatchEl.classList.add('vanish'); }
    if (agentDeferredEl) { agentDeferredEl.classList.add('vanish'); }
    if (agentExcludedEl) { agentExcludedEl.classList.add('vanish'); }
    if (coSponsorExcludedEl) { coSponsorExcludedEl.classList.add('vanish'); }
    errorEl.classList.add('vanish');

    fetch(`${urlPrefix}&email=${emailField.value}&country_code=${this.selectedCountryValue}`)
      .then(response => response.json())
      .then(data => {
        if (data === null) {
          // Handle null data if necessary
        } else if (data.error) {
          if (data.error === notFoundError ||
            data.error === 'Agent active date outside window' ||
            data.error === 'Secondary agent error' ||
            data.error === 'Agent email does not match' ||
            data.error === 'Agent is deferred' ||
            data.error === 'Agent excluded' ||
            data.error === 'Co-sponsor excluded'
          ) {
            document.querySelector(confirmationSelector).classList.add('vanish');

            if (data.error === 'Agent active date outside window') {
              agentActiveDateErrorEl.classList.remove('vanish');
            } else if (data.error === 'Secondary agent error') {
              secondaryAgentErrorEl.classList.remove('vanish');
            } else if (data.error === 'Agent email does not match') {
              agentEmailMatchEl.classList.remove('vanish');
            } else if (data.error === 'Agent is deferred') {
              agentDeferredEl.classList.remove('vanish');
            } else if (data.error === 'Agent excluded') {
              agentExcludedEl.classList.remove('vanish');
            } else if (data.error === 'Co-sponsor excluded') {
              coSponsorExcludedEl.classList.remove('vanish');
            } else if (confirmationSelector) {
              errorEl.classList.remove('vanish');
            }

            emailField.classList.add("input--has-error");
            inputSubmitBtnText.textContent = "Error";
            inputSubmitBtn.setAttribute("data-label", "Error");
          } else {
            inputSubmitBtnText.textContent = "Submit";
            super.renderToast("global-flash-msg-container", generalError, "danger", false, null, 6000);
          }
          selectionFormSubmitBtn.setAttribute("disabled", "disabled");
          selectionFormSubmitBtn.classList.add("disabled");
        } else {

          if (data.admin_error === 'Secondary agent error') {
            secondaryAgentErrorEl.classList.remove('vanish');
          };

          for (const [key, selector] of Object.entries(fieldSelectors)) {
            document.querySelector(selector).value = data[key] ?? "";
          }
          emailField.classList.remove("input--has-error");
          inputSubmitBtnText.textContent = "Submitted";
          inputSubmitBtn.classList.add("is-submitted");
          inputSubmitBtn.removeAttribute("data-label");
          if (document.querySelector(checkboxSelector).checked) {
            selectionFormSubmitBtn.removeAttribute("disabled");
            selectionFormSubmitBtn.classList.remove("disabled");
          }
          if (successCallback) { successCallback(); }
        }
      }).finally(() => {
        inputSubmitBtnLoader.classList.add("vanish");
        inputSubmitBtn.removeAttribute('disabled');
      });
  }
}